/*
 * Copyright (c) 2020 SQUAREPING INC.
 *
 * SQUAREPING CONFIDENTIAL
 * [2019 and Beyond] SQUAREPING INC. All Rights Reserved.
 *
 * NOTICE: The source code contained herein is, and remains the property of SQUAREPING INC.
 * and its suppliers, if any. The intellectual and technical concepts contained herein are
 * proprietary to SQUAREPING INC. and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 *
 * Dissemination of this information or reproduction of this material is strictly forbidden
 * anywhere in the world unless prior written permission is obtained from SQUAREPING INC.
 */

const translations = {
  label: {
    numMembers: '{{num}} member(s)',
    title: 'Business Name',
    subTitle: 'Business Slogan',
    active: 'Active',
    inActive: 'Inactive',
    supportTeam: 'SQUAREPING Support Team',
    selectedItems: 'Selected {{num}} items',
    businessWebsite: 'Business website',
    monthlyFee: 'Monthly fee',
    defaultAvatar: 'Business Logo',
    businessAvatar: 'Business Logo',
    phoneNoCountryCode: 'Phone',
    countryCode: 'Country',
    ok: 'OK',
    cancel: 'Cancel',
    login: 'Login',
    add: 'Add',
    addMultiple: 'Add Range',
    autoRenewal: 'Auto renewal',
    autoRenewalOn: 'On',
    autoRenewalOff: 'Off',
    turnOffAutoRenew: 'Turn off auto renewal',
    turnOnAutoRenew: 'Turn on auto renewal',
    activateSubscription: 'Activate subscription',
    renewSubscription: 'Renew subscription',
    cancelSubscription: 'Cancel subscription',
    pauseSubscription: 'Pause service', // put subscription to inactive status, continue to charge
    resumeSubscription: 'Resume service', // put subscription to active status
    resume: 'Resume',
    cardList: 'Payment card list',
    card: 'Card',
    cardInfo: 'Card information',
    registerNewAccount: 'Register new account',
    register: 'Register',
    createSubscription: 'Create subscription',
    companyBanner: 'Business Banner',
    preview: 'Preview',
    pingDesignTitle: 'Call screen for guest',
    activeBusiness: 'Activate',
    businessInActive: 'Inactive',
    businessActive: 'Active',
    deleteCard: 'Delete card',

    localLevel1: 'State',
    localLevel2: 'City',
    localLevel3: '',

    loadingData: 'Loading data...',

    guestName: 'Guest name',
    guest: 'Guest',
    checkOut: 'Check-out',
    claimed: 'Claimed',
    empty: 'Empty',
    search: 'Search',
    poweredBy: 'Powered by',
    confirmBillingCycle: 'Confirm your billing cycle',
    discountCode: 'Discount code (if any)',
    apply: 'Apply',

    startNumber: 'Start number',
    endNumber: 'End number',
    confirm: 'Confirm',
    companyLogo: 'Company logo',
    design: 'Business Branding',
    start: 'Start',
    end: 'End',
    autoGenerate: 'Auto generate',
    manual: 'Manual',
    update: 'Update',
    reset: 'Reset',
    offboarding: 'Off-boarding',
    yes: 'Yes',
    no: 'No',
    selectThisPayment: 'Select this payment method',
    addPayment: 'Add payment',
    updatePayment: 'Change payment',
    makeDefault: 'Make default',
    delete: 'Delete',
    asLink: 'As Link',
    asImage: 'As Image',
    profile: 'Profile',
    help: 'Help',
    ppHelp: 'https://squareping.com/hppams/',
    signOut: 'Sign out',
    download: 'Download',
    newBusiness: 'New business',
    address: 'Address',
    businessEmail: 'Business email',
    continue: 'Continue',
    close: 'Close',
    resend: 'Resend',
    date: 'Date',
    amount: 'Amount',
    package: 'Package',
    updatePassword: 'Update password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    save: 'Save',
    payment: 'Payment',
    exts: 'Extensions',
    addExts: 'Add {{extensions, lowercase}}',
    addExt: 'Add {{extension, lowercase}}',
    addField: 'Add {{field, lowercase}}',
    newField: 'New {{field, lowercase}}',
    updateField: 'Update {{field, lowercase}}',
    cancelField: 'Cancel {{field, lowercase}}',
    startField: 'Start {{field, lowercase}}',
    enterField: 'Enter {{field, lowercase}}',
    deActivateField: 'De-activate {{field, lowercase}}',
    deActiveBusiness: 'De-activate business',
    ext: '{{extension}}',
    extCode: '{{extension}}',
    claimCode: 'Passcode',
    startExt: 'Start {{extension, lowercase}}',
    endExt: 'End {{extension, lowercase}}',
    passCode: 'Passcode',
    digitNumber: '{{num}}-digit number',
    claimTime: 'Claim time',
    registeredAt: 'Registered at',
    claimBy: 'Claim by',
    user: 'User',
    status: 'Status',
    postStatus: {
      DRAFT: 'Draft',
      PUBLISHED: 'Published',
      EXPIRED: 'Expired',
      ARCHIVED: 'Archived',
    },
    action: 'Action',
    extList: '{{extension}} list',
    subs: 'Subscription',
    businessSubs: 'Business subscription',
    business: 'Business',
    cardHolderName: 'Card holder name',
    cardType: 'Card type',
    createTime: 'Create time',
    default: 'Default',
    subss: 'Subscriptions',
    expireDate: 'Expire date',
    cardNumber: 'Card number',
    firstBillingDate: 'First billing date',
    currentBillingPeriod: 'Current billing period',
    nextBillingDate: 'Next billing date',
    nextBillingPeriodAmount: 'Next billing period amount',
    claimTag: '{{extension, firstCapEachWord}} Claim Tag',
    pingTag: 'CALL Tag',
    claimServiceTag: 'Service Join Tag',
    manageExts: 'Manage {{extensions, lowercase}}',
    layoutPing: 'Layout call screen',
    businessInfo: 'Business information',
    contactInfo: 'Contact',
    adminContact: 'Administrative Contact',
    adminContactSubtitle: 'Contact details and who can manage this subscription.',
    changeAdministrator: 'Change Administrator',
    adminContactDelegate: 'Subscription Administrator',
    adminContactHint: 'Use Account Administrator by default, or assign another email to manage this subscription.',
    adminContactCurrent: 'Current administrator',
    adminContactChange: 'Update email',
    adminContactAssign: 'Assign email',
    adminContactRemove: 'Reset default',
    adminContactNone: 'Account Administrator (default)',
    businessAddress: 'Business address',
    streetAddress: 'Street address',
    businessStreetAddress: 'Business street address',
    businessName: 'Business name',
    businessPhone: 'Business phone number',
    phoneNumber: 'Phone number',
    email: 'Email',
    country: 'Country',
    postalCode: 'Postal code',
    zipCode: 'Zip code',
    newSubscription: 'New subscription',
    newPayment: 'New payment',
    verifyEmail: 'Verify email',
    firstName: 'First name',
    lastName: 'Last name',
    position: 'Position',
    positionPlaceholder: 'e.g. Manager, Owner, Owner Son',
    password: 'Password',
    confirmPassword: 'Confirm password',
    type: 'Type',
    businessType: 'Business type',
    otherBusinessType: 'Specify business type',
    otherBusinessTypePlaceholder: 'Enter business type',
    lodging: 'Lodging',
    residential: 'Residential',
    name: 'Name',
    contactInformation: 'Contact information',

    paymentMethod: 'Payment method',

    promptString: 'Prompt string',
    selectPayment: 'Select your payment method',
    verifyPayment: 'Verify your payment method',
    reviewOrder: 'Review your order',
    startYourSubs: 'Start your subscription',
    resetPassword: 'Reset password',
    forgotPassword: 'Forgot password',
    signIn: 'Sign in',
    yourPasscode: 'Your passcode',
    thisIsMyAccount: 'This is my account',
    createNewAccount: 'Create a new account',
    verifySuccess: 'Successfully verified',
    verifyFailed: 'Unsuccessfully verified',
    tryAgain: 'Try again',
    upload: 'Upload',
    //
    loginID: 'Login ID',
    slogan: 'Slogan',
    activate: 'Activate',
    branding: 'Business Branding',
    copyBrandingFrom: 'Import business branding elements from',
    selectSubscription: 'Select a subscription',
    none: 'None',
    startFreeTrial: 'Start your 30-day free trial',
    trialInfo: 'No charge for 30 days · Cancel anytime',
    trialEndsOn: 'Trial ends {{date}}',
    firstChargeOn: 'First charge on {{date}}',
    confirmTrial: 'Start free trial',
  },
  msg: {
    adminContactRemoveConfirm: 'Remove this subscription administrator assignment?',
    pleaseFinishCaptchaVerification: 'Please finish robot verification',
    passwordHint: 'Use 8 or more characters with a mix of letters, numbers & symbols',
    passwordMinRule: 'Minimum password length is 8 characters',
    passwordMaxRule: 'Maximum password length is 16 characters',
    passwordSpaceRule: 'Password must not contain space',
    passwordDigitRule: 'Password must have at least one digit',
    passwordLowercaseRule: 'Password must have at least one lowercase character',
    passwordUppercaseRule: 'Password must have at least one uppercase character',
    passwordSpecialRule: 'Password must have at least one special character',
    subsPriceUpdated: 'Your new monthly subscription fee will be {{price}} on the next billing cycle.',
    bannerHint: 'Recommended size (640x300)',
    copyBrandingHint: 'Copy banner, logo, and slogan from another subscription.',
    brandingWillBeCopied: 'The following branding components will be copied:',
    autoRenewalOffWarning: 'This subscription will be automatically canceled on the next billing cycle.',
    addMultipleExtSuccess: '{{number}} {{extension, lowercase}}(s) has been added.',
    changeExtensionTypeConfirm: 'Existing {{extension, lowercase}} list will be reset for new call plan to take effect, are you sure?',
    cancelSubsConfirm: 'PINGPAD service will stop immediately after cancellation. Are you sure?',
    pauseSubsConfirm: 'PINGPAD service will stop immediately until resume. Are you sure?',
    activateSubsConfirm: 'Do you want to activate this business?',
    selectPaymentCardFor: `Select payment card for {{business}}'s subscription`,
    duplicateExtension: '{{extension}} number already exists, please enter another {{extension, lowercase}} number.',
    input: 'Input {{field, lowercase}}',
    cancelAnyTime: 'You can cancel anytime.',
    subscriptionStepsHint: 'Complete your subscription in 3 simple steps.',
    verifySuccess: 'Your email address successfully verified!\nYou will soon receive another email message to login your account on approval\nThank you for your business',
    verifyFailed: 'Verification of your group account failed!\nPlease try again or contact our support team for assistant',
    newToPING: 'New to PINGPAD?',
    signUpNewAccount: 'Sign up a new account here',
    loginTitle: 'Welcome to PINGPAD',
    resendSuccessful: 'Passcode successfully sent!',
    resetPassHint: 'Enter your registered email to reset your password.',
    pleaseConfirmNewPass: 'Please confirm your new password!',
    pleaseConfirmPass: 'Please confirm your password!',
    pleaseSelectPayment: 'Please select a payment method',
    endExtMustLarger: 'End {{extension, lowercase}} number must be larger than that of Start {{extension, lowercase}}.',
    createSuccess: '{{field, firstCap, autoSpace}}created successfully!',
    updateSuccess: '{{field, firstCap, autoSpace}}updated successfully!',
    removeSuccess: '{{field, firstCap, autoSpace}}removed successfully!',
    cancelSuccess: '{{field, firstCap, autoSpace}}cancelled successfully!',
    addSuccess: '{{field, firstCap, autoSpace}}added successfully!',
    startSuccess: '{{field, firstCap, autoSpace}}started successfully!',
    deActiveSuccess: '{{field, firstCap, autoSpace}}de-activated successfully!',
    resetSuccess: '{{field, firstCap, autoSpace}}reset successfully!',
    pleaseSelect: 'Please select {{field, lowercase}}',
    pleaseInput: 'Please enter {{field, lowercase}}',
    emailAlreadyExists: 'This email is already registered. The user will be linked to this extension.',
    fieldInvalid: 'Please enter a valid {{field, lowercase}}',
    numberInvalid: '{{field, firstCap}} must be a valid number',
    maxLengthInvalid: 'Maximum length of {{field, lowercase}} is {{max}}',
    lengthInvalid: 'Length of {{field, lowercase}} is {{max}}',

    resetExtConfirm: 'Are you sure to reset this {{extension}}?',
    offboardingExtConfirm: 'Are you sure to off-board this {{extension}}? User data will be cleared.',
    removeConfirm: 'Are you sure to remove this {{field, lowercase}}?',
    unClaimConfirm: 'Are you sure to unclaim this {{field, lowercase}}?',
    cancelConfirm: 'Are you sure to cancel this {{field, lowercase}}?',
    invalidExtCode: '{{extension}} code composes only alphanumeric characters',
    extensionRangeMaxLength: 'Max. 6 alphanumeric chars, ending with decimal digits',
    extensionRangeEndWithDigits: 'Start and end extension must end with decimal digit(s).',

    intlNumberWithOptions: 'Some {{val, lowercase}}',

    requireClaimCodeForExt: 'Require passcode',

    cannotLoadData: 'Cannot load data',
    cannotLoadPaymentMethod: 'Cannot load payment method',

    unclaimSuccess: 'Unclaim successfully',

    cancelBusinessSubsConfirm: 'Are you sure to cancel PINGPAD service subscription for this business?',
    cancelBusinessConfirm: 'Are you sure to deactivate PINGPAD service for this business?',

    extensionQuotaExceeded: 'Extension limit reached ({{current}}/{{max}}). Please upgrade your plan.',
    errorTryAgain: 'An error happened, please try again!',
    confirmDontMatch: 'Password and confirm password do not match',
    pleaseVerifyEmail: 'You will soon receive an email verification message. Please check your email Inbox (or Spam folder).',
    pleaseChooseCountry: 'Please choose a  country',
    streetPlaceHolder: 'Street address, township, city, state...',
    cancelSubsBeforeDeletePayment: 'Please cancel any subscriptions associated with this payment method to delete it.',
    invalidDiscount: 'Invalid discount code',
    discountApplySuccess: 'Discount applied successfully!',
    cannotApplyDiscount: 'Cannot apply discount code, please try again',
    cardVerifyFail: 'Card verification failed!, please check your card!',
    reviewOrder1a: 'After subscription starts,',
    reviewOrder1b: ' your payment will be charged ${{price}} (plus tax)',
    reviewOrder2a: 'The plan will automatically renew at every billing cycle.',
    reviewOrder2b: ' To avoid subscription charge for subsequence billing cycles, turn off auto renewal or cancel subscription before the renewal date.',
    reviewOrder3a: 'By placing this order you agree to our ',
    reviewOrder3b: 'terms of service',
    reviewOrder3c: ". To ensure continued service, we'll store and update (e.g., upon expiration) your payment information. Prices may change.",

    emailNotConfirm: 'Your email has not been confirmed',
    verifyEmailHint:
      "Please check your inbox (or spam folder) for email verification message from SQUAREPING and click on 'Verify email address' link in the message to complete registration.",
    resendVerifyEmailHint: "Didn't receive the email? Resend verification email",
    resendVerifyEmailSuccess: 'Verification email has been resent. Please check your inbox.',

    accountNotApproved: 'Your account has not been approved',
    approveHint: 'Your account is under review. Account status update will be sent to your registered email address.',

    blockHint1: 'Your account has been suspended. Contact  ',
    blockHint2: '  for resolution.',

    resendPasscodeHint: "Didn't received your passcode ? Resend passcode now",
    areYou: 'Are you ',
    inputEmailToContinue: 'Input your email to continue',
    createAccountHint: "Can't remember this email address ? Create a new account",
    invalidResetPassLink: 'Invalid reset password link!',
    resetPassSuccess: 'Password reset successfully',
    resetYourAccount: 'Reset your account',

    cancelSubsWarning: 'PINGPAD service will be stopped effectively after 7 days from the time of cancellation.',
    qrLinkSaved: 'QR Link has been saved to clipboard.',
    /////
    imgNotSupported: 'Image type {{type}} is not supported, please select a file from one of these types: {{types}}',
    imgSizeExceed: 'Maximum size of image is {{size}} MB',
    searchExtHint: 'Search {{extension, lowercase}}',
    searchPostHint: 'Search posts',
  },
  subscription: {
    discount: 'Discount',
    total: 'Total',
    subTotal: 'Subtotal',
    monthlyTotal: 'Monthly total',
    freeTrialCode: '30-day free trial',
    startTrialCta: '30-day free trial',
    missingPaymentForTrial: 'Add a payment method to start your free trial.',
    trialStartedSuccess: 'Your 30-day free trial has started.',
    renewSubscription: 'Renew subscription',
    renewedSuccess: 'Your subscription has been renewed.',
    subscribeCta: 'Subscribe',
    promoAndDiscountCode: 'Promo and Discount code',
    promoAndDiscountCodePlaceholder: 'Enter promo and discount code',
    trialCodeHint: '',
    subscribeDisclaimer: "You won't be charged until you confirm.",
    trialBillingDisclaimer: 'Trial pricing is applied only when your code is valid.',
    nextChargeLabel: 'Next charge:',
    endsOnLabel: 'Subscription ends:',
    cancellationAlreadyScheduled: 'Cancellation already scheduled',
    reactivateSubscription: 'Reactivate subscription',
    reactivationSuccess: 'Subscription reactivated successfully.',
    updateRequiresChanges: 'Change your plan or extension count to update',
    noPlanChangesDetected: 'Make a change to your plan or extension count before updating.',
    trialDaysRemainingOne: '1 day left in trial',
    trialDaysRemainingOther: '{{count}} days left in trial',
    basePrice: 'Subscription price',
    extensionCount: 'Number of {{extensions, lowercase}}',
    extensionPrice: 'Monthly subscription fee per {{extensions, lowercase}}',
  },
  serviceTag: {
    changePasscode: 'Change passcode',
    service: 'Service',
    activate: 'Activate',
    deActivate: 'Pause',
    manage: 'Manage services',
    unClaim: 'Reset',
    unClaimConfirm: 'Are you sure to reset this service tag?',
    noEmployee: 'Not claimed',
    type: {
      Operator: 'Operator',
      Lobby: 'Lobby',
      Security: 'Security',
      Parking: 'Parking',
      WIFI: 'WIFI',
      RoomService: 'Room Service',
      Massage: 'Massage',
      FoodDrink: 'Food&Drink',
      Restaurant: 'Restaurant',
      ConvenientStore: 'Convenient Store',
      FitnessCenter: 'Fitness Center',
      SwimmingPool: 'Swimming Pool',
      Spa: 'Spa',
      Office: 'Office',
      Maintenance: 'Maintenance',
      Laundry: 'Laundry',
      Custom: 'Custom',
    },
  },
  payment: {
    transferSubsTo: 'Transfer subscriptions to',
  },
  braintree: {
    chooseAnotherWayToPay: 'Choose another payment method',
    otherWaysToPay: 'Other payment methods',
    payWithCard: 'Use card',
    chooseAWayToPay: 'Choose a payment method',
    //form
    cardholderNameLabel: 'Cardholder Name',
    cardNumberLabel: 'Card Number',
    cvvLabel: 'CVV',
    cvvThreeDigitLabelSubheading: '(3 digits)',
    cvvFourDigitLabelSubheading: '(4 digits)',
    expirationDateLabel: 'Expiration Date',
    expirationDateLabelSubheading: '(MM/YY)',
    cardholderNamePlaceholder: '',
    expirationDatePlaceholder: 'MM/YY',
    postalCodeLabel: 'Postal Code',
    saveCardLabel: 'Save card',

    // Errors
    fieldEmptyForCvv: 'Please fill out a CVV.',
    fieldEmptyForExpirationDate: 'Please fill out an expiration date.',
    fieldEmptyForCardholderName: 'Please fill out a cardholder name.',
    fieldEmptyForNumber: 'Please fill out a card number.',
    fieldEmptyForPostalCode: 'Please fill out a postal code.',
    fieldInvalidForCardholderName: 'This cardholder name is not valid.',
    fieldInvalidForCvv: 'This security code is not valid.',
    fieldInvalidForExpirationDate: 'This expiration date is not valid.',
    fieldInvalidForNumber: 'This card number is not valid.',
    fieldInvalidForPostalCode: 'This postal code is not valid.',
    fieldTooLongForCardholderName: 'Cardholder name must be less than 256 characters.',
    genericError: 'Something went wrong on our end.',
    hostedFieldsTokenizationFailOnDuplicateError: 'This credit card already exists as a saved payment method.',
    hostedFieldsFailedTokenizationError: 'Please check your information and try again.',
    hostedFieldsTokenizationCvvVerificationFailedError: 'Credit card verification failed. Please check your information and try again.',
    hostedFieldsTokenizationNetworkErrorError: 'Network error. Please try again.',
    hostedFieldsFieldsInvalidError: 'Please check your information and try again.',
    paypalButtonMustBeUsed: 'Use the PayPal button to continue with your payment.',
    paypalAccountTokenizationFailedError: 'Something went wrong adding the PayPal account. Please try again.',
    paypalFlowFailedError: 'Something went wrong connecting to PayPal. Please try again.',
    paypalTokenizationRequestActiveError: 'PayPal payment authorization is already in progress.',
    vaultManagerPaymentMethodDeletionError: 'Unable to delete payment method, try again.',
    unsupportedCardTypeError: 'This card type is not supported. Please try another card.',
  },
  extension: {
    changePasscode: 'Change passcode',
    managementMethod: 'Call plan',
    typeFlex: 'Internet or phone',
    typePhone: 'Phone only',
    flexHint: '{{extension}} can be setup for Internet audio/video call or mobile call.',
    phoneHint: '{{extension}} is for mobile call only.',
    premiumHint: 'With support for several enhanced functions.',
    extensionHint: 'Up to 6 alphanumeric characters.',
    extensionRangeHint:
      'Extension can be up to 6 alphanumeric characters. For range specification, start and end extensions must end with a number. Both can be prefixed with alphabetic characters, e.g. ABC100 - ABC650',
    claimCodeHint1: 'Passcode is required when user claims {{extension, lowercase}}.',
    autoGenerateClaimCode: '4-digit passcode will be auto generated for every {{extension, lowercase}}.',

    removeManyConfirm: 'Are you sure to remove selected {{extensions, lowercase}}?',
    removeManySuccess: 'Remove successfully!',

    clearManyConfirm: 'Are you sure to clear selected {{extensions, lowercase}}?',
    offboardingExtConfirm: 'Are you sure to off-board this {{extension}}? User data will be cleared.',
    offboardingManyConfirm: 'Are you sure to off-board selected {{extensions, lowercase}}? User data will be cleared.',
    clearManySuccess: 'Clear successfully!',

    tableTotal: 'Total: {{total}}',
    tableTotalVsActive: 'Total: {{total}} · Active: {{active}}',
    summaryTotal: 'Total',
    summaryActive: 'Active',
    requireClaimCodeConfirm: 'Passcode is required to claim extension',
    notRequireClaimCodeConfirm: 'Passcode is not required to claim extension',

    checkInSuccess: 'Added successfully!',
    addGuestTitle: 'Add new guest',
    onboardingTitle: 'On-boarding',
    onboardingSuccess: 'User onboarded successfully.',
    importUsers: 'Import Users',
    importUsersSubtitle: 'Bulk onboard users from a CSV file',
    importUsersStepVerify: 'Verify',
    importUsersStepImport: 'Import',
    importUsersDownloadTemplate: 'Download CSV Template',
    importUsersDraggerText: 'Click or drag a CSV file here',
    importUsersDraggerHint: 'Only .csv files. Required columns: email, extensionCode',
    importUsersVerifying: 'Verifying {{current}} / {{total}}…',
    importUsersVerifySuccess: '{{total}} row(s) validated. Ready to import.',
    importUsersVerifyError: 'Row {{row}} — {{field}}: {{message}}',
    importUsersVerifyFix: 'Fix: {{fix}}',
    importUsersProceed: 'Proceed to Import',
    importUsersImporting: 'Importing {{current}} / {{total}}…',
    importUsersImportSuccess: '{{total}} user(s) imported successfully.',
    importUsersDownloadErrors: 'Download error log',
    importUsersImportError: 'Row {{row}} ({{email}} / Ext {{code}}): {{message}}',
    importUsersClose: 'Close',
    importUsersReset: 'Import another file',
    resendWelcome: 'Resend Welcome',
    resendWelcomeConfirm: 'Resend the welcome email to this user?',
    resendWelcomeSuccess: 'Welcome email has been resent.',
    resendWelcomeFailed: 'Failed to resend welcome email.',
    userProfileTitle: 'User profile',
    unClaimAction: 'Clear',
    unClaimConfirm: 'Are you sure to clear this {{extension, lowercase}}?',

    requireClaimCodeEnabled: 'Require passcode enabled',
    requireClaimCodeDisabled: 'Require passcode disabled',

    unit: {
      extension: 'Extension',
      room: 'Room',
      unit: 'Unit',

      extensionFull: 'Extension',
      roomFull: 'Room extension',
      unitFull: 'Unit extension',

      extensionFullPlural: 'Extensions',
      roomFullPlural: 'Room extensions',
      unitFullPlural: 'Unit extensions',

      extensionPlural: 'Extensions',
      roomPlural: 'Rooms',
      unitPlural: 'Units',
    },
  },
  business: {
    serviceOptions: 'Service options',
    serviceLevel: 'Service level',
    serviceLevelPremium: 'Premium',
    serviceLevelStandard: 'Basic',
    setting: {
      requirePasscodeOption: 'Require {{extension, lowercase}} passcode',
    },

    lodging: 'Hospitality',
    residential: 'Residential Communities',
    office: 'Commercial Property',
    education: 'Education',
    governmentOffices: 'Government Offices',
    remoteMobileStaff: 'Remote/Mobile Staff',
    other: 'Other',

    lodgingHint: 'Hotel, Resort, Motel, Vacation Rental, Short-term Rental',
    residentialHint: 'Apartment, Condominium, Gated Community, Student Housing, Senior Living',
    officeHint: 'Office Building, Business Park, Medical Office Building, Retail Center, Warehouse/Industrial, Mixed-Use Property',
    educationHint: 'School, Community College, University Campus Offices',
    governmentOfficesHint: 'Municipal, County, State, and Federal government service offices',
    remoteMobileStaffHint: 'Remote or mobile staff operations.',
  },
  design: {
    // pingTitle: 'Call screen for guest',
    // claimTitle: 'Claim extension screen for guest',
    // pingLabel: 'Design call screen',
    // claimLabel: 'Design claim screen',
    label: 'Business Branding',
    settings: 'Screen settings',
    callPreview: 'Call screen',
    claimPreview: 'Extension Claim screen',
    incomingPreview: 'Incoming Call Screen',

    callHint: 'Caller will see this screen when placing a call via the CALL tag.',
    claimHint: 'User will see this screen when scanning JOIN tag to join their {{extension, lowercase}}.',

    sloganHint: 'Enter business slogan/tagline',
    sloganDefault: 'Business Slogan/Tagline',

    // callPromptString: 'Call prompt string',
    // callPromptStringDefault: 'Enter {{extension}} to call',
    // callPromptStringHint: '',
    //
    // claimPromptString: 'Claim prompt string',
    // claimPromptStringDefault: 'Enter {{extension}} to claim',
    // claimPromptStringHint: '',

    extensionUnitSetting: 'Extension Label',
  },
  register: {
    emailExistMsg1: "There's an account associated with your email address, please",
    emailExistMsg2: 'instead',
  },
  about: {
    title: 'About',
    version: 'Version',
    build: 'Build number',
    buildDate: 'Build date',
    feedback: 'Send feedback',
    terms: 'Terms & Conditions',
    policy: 'Privacy Policy',
    disclaimer: 'Disclaimer',
    parentalConsentForm: 'Parental consent form',
    feedbackSubject: 'Feedback',
    feedbackBody:
      "Please share your feedback or questions with us below (e.g. tell us what you like, dislike, etc):\n\n\n\n\n---------------\nPlease don't mind this part. It's for us!\nModel: {{model}}\nOS Version: {{osVersion}}\nApp Version: {{appVersion}}\nUID: {{uid}}",
  },
  adminAccounts: {
    title: 'Accounts',
    suspenseConfirm: 'Are you sure to suspend PINGPAD service for this account?',
    approveConfirm: 'Are you sure to activate this account?',
    suspenseTitle: 'Suspend service',
    suspenseReason: 'Suspension reason',
    approve: 'Approve',
    suspense: 'Suspend',
    resume: 'Resume',
    viewSubs: 'View subscriptions',
    activeSubscription: 'Active subscriptions',
    totalExtensions: 'Total {{extensions}}',
    activeExtensions: 'Active {{extensions}}',
    deleteTitle: 'Mark account as deleted',
    deleteConfirm: 'Are you sure to mark this account as deleted? This is a soft delete.',
    deleteReason: 'Deletion reason (optional)',
    delete: 'Delete',
  },
  adminSubscription: {
    title: 'Subscriptions',
    servicePlan: 'Service Plans',
    quota: 'Quota',
    quotaTitle: 'Subscription Quota',
    quotaHint: 'Set resource limits for this subscription. Admin can override plan defaults.',
    currentUsage: 'Current usage',
    extensionsUsage: 'Extensions: {{current}} / {{limit}}',
    maxExtensions: 'Max extensions',
    quotaSaved: 'Quota updated successfully',
    resetToDefaults: 'Reset to default',
    downgradeBlockedTitle: 'Cannot downgrade yet',
    downgradeBlockedIntro: 'Please reduce the following resources before downgrading to {{plan}}:',
    downgradeBlockerMessage: 'You have {{current}} {{resource}}. The new plan allows max {{max}}. Please remove {{toRemove}} before downgrading.',
    downgradeGoTo: 'Go to {{resource}}',
    servicePlanFeaturesTitle: 'Features included',
    servicePlanFeaturesIntro: 'Detailed capabilities included in Standard and all higher plans.',
    servicePlanPricingTitle: 'Extension & add-on pricing',
    servicePlanPricingIntro: 'Monthly extension tiers and optional add-ons. Base plan is billed separately.',
    extensionsPricingLabel: 'Extensions',
    addonsPricingLabel: 'Add-ons',
    addonUnitBoard: 'board',
    addonUnitUnit: 'unit',
  },
  sidebar: {
    groupBusiness: 'Business',
    groupCommunication: 'Call Service',
    groupAccessControl: 'Access Control',
    groupVisitors: 'Visitors',
    businessProfile: 'Business Profile',
    servicePlans: 'Service Plans',
    branding: 'Branding',
    roles: 'Roles',
    policies: 'Policies',
    extensions: 'Extensions',
    bulletinBoard: 'Communication Center',
    callAuditLog: 'Call Audit Log',
    visitorManagement: 'Visitor Management',
    entranceManagement: 'Entrance Management',
    doorManagement: 'Door Management',
    services: 'Services',
  },
  scheduleDeactivation: {
    title: 'Schedule Service Deactivation',
    whenDeactivate: 'When should the service be deactivated?',
    immediately: 'Immediately',
    atDateTime: 'At',
    dateTimeLabel: 'Date & time',
    deactivateDateTimeLabel: 'Deactivation date & time',
    resumeDateTimeLabel: 'Resume date & time',
    date: 'Date',
    time: 'Time',
    selectDateTime: 'Please select date and time',
    reason: 'Reason for deactivation',
    reasonRequired: 'Please provide a reason',
    reasonMinLength: 'Reason must be at least {{count}} characters',
    reasonMaxLength: 'Reason must not exceed {{count}} characters',
    reasonPlaceholder: 'e.g. Seasonal closure, temporary suspension...',
    whenResume: 'What happens after deactivation?',
    resumeAt: 'Service will resume at',
    endPermanently: 'Service will end permanently',
    submit: 'Schedule Deactivation',
    resumeAfterDeactivate: 'Resume date must be after deactivation date',
  },
};

export default translations;
